//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AttachmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param inputValue (optional) 
     * @param templateVersionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    attachmentsPOST(inputValue: string | undefined, templateVersionId: string | undefined, file: FileParameter | undefined): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/attachments?";
        if (inputValue === null)
            throw new Error("The parameter 'inputValue' cannot be null.");
        else if (inputValue !== undefined)
            url_ += "inputValue=" + encodeURIComponent("" + inputValue) + "&";
        if (templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' cannot be null.");
        else if (templateVersionId !== undefined)
            url_ += "templateVersionId=" + encodeURIComponent("" + templateVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processAttachmentsPOST(response: HttpResponseBase): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param flowId (optional) 
     * @param flowStepId (optional) 
     * @param flowStepToId (optional) 
     * @param attachId (optional) 
     * @param version (optional) 
     * @return OK
     */
    attachmentsGET(flowId: string | undefined, flowStepId: string | undefined, flowStepToId: string | undefined, attachId: string | undefined, version: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/attachments?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        if (flowStepId === null)
            throw new Error("The parameter 'flowStepId' cannot be null.");
        else if (flowStepId !== undefined)
            url_ += "FlowStepId=" + encodeURIComponent("" + flowStepId) + "&";
        if (flowStepToId === null)
            throw new Error("The parameter 'flowStepToId' cannot be null.");
        else if (flowStepToId !== undefined)
            url_ += "FlowStepToId=" + encodeURIComponent("" + flowStepToId) + "&";
        if (attachId === null)
            throw new Error("The parameter 'attachId' cannot be null.");
        else if (attachId !== undefined)
            url_ += "AttachId=" + encodeURIComponent("" + attachId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAttachmentsGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param flowId (optional) 
     * @param taskId (optional) 
     * @param taskToId (optional) 
     * @param attachId (optional) 
     * @param version (optional) 
     * @return OK
     */
    attachmentsDELETE(flowId: string | undefined, taskId: string | undefined, taskToId: string | undefined, attachId: string | undefined, version: number | undefined): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/attachments?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "flowId=" + encodeURIComponent("" + flowId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (taskToId === null)
            throw new Error("The parameter 'taskToId' cannot be null.");
        else if (taskToId !== undefined)
            url_ += "taskToId=" + encodeURIComponent("" + taskToId) + "&";
        if (attachId === null)
            throw new Error("The parameter 'attachId' cannot be null.");
        else if (attachId !== undefined)
            url_ += "attachId=" + encodeURIComponent("" + attachId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processAttachmentsDELETE(response: HttpResponseBase): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputValue (optional) 
     * @param templateVersionId (optional) 
     * @param file (optional) 
     * @return OK
     */
    guestPOST(inputValue: string | undefined, templateVersionId: string | undefined, file: FileParameter | undefined): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/attachments/guest?";
        if (inputValue === null)
            throw new Error("The parameter 'inputValue' cannot be null.");
        else if (inputValue !== undefined)
            url_ += "inputValue=" + encodeURIComponent("" + inputValue) + "&";
        if (templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' cannot be null.");
        else if (templateVersionId !== undefined)
            url_ += "templateVersionId=" + encodeURIComponent("" + templateVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuestPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuestPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processGuestPOST(response: HttpResponseBase): Observable<AttachmentDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param flowId (optional) 
     * @param flowStepId (optional) 
     * @param flowStepToId (optional) 
     * @param attachId (optional) 
     * @param version (optional) 
     * @return OK
     */
    guestGET(token: string, email: string, tenantId: string, flowId: string | undefined, flowStepId: string | undefined, flowStepToId: string | undefined, attachId: string | undefined, version: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/attachments/guest?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined and cannot be null.");
        else
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        if (flowStepId === null)
            throw new Error("The parameter 'flowStepId' cannot be null.");
        else if (flowStepId !== undefined)
            url_ += "FlowStepId=" + encodeURIComponent("" + flowStepId) + "&";
        if (flowStepToId === null)
            throw new Error("The parameter 'flowStepToId' cannot be null.");
        else if (flowStepToId !== undefined)
            url_ += "FlowStepToId=" + encodeURIComponent("" + flowStepToId) + "&";
        if (attachId === null)
            throw new Error("The parameter 'attachId' cannot be null.");
        else if (attachId !== undefined)
            url_ += "AttachId=" + encodeURIComponent("" + attachId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuestGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuestGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGuestGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @return OK
     */
    recaptcha(): Observable<string> {
        let url_ = this.baseUrl + "/configuration/recaptcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRecaptcha(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataDomainClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param versionId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    dataSource(domainId: string, versionId: string | undefined, filter: string | undefined): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/data-domain/data-source/{domainId}?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processDataSource(response: HttpResponseBase): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataDomainSourceDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param versionId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    dataSourceGuest(domainId: string, versionId: string | undefined, filter: string | undefined): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/data-domain/data-source-guest/{domainId}?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataSourceGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataSourceGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processDataSourceGuest(response: HttpResponseBase): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataDomainSourceDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param versionId (optional) 
     * @param dependenciesNames (optional) 
     * @param dependenciesValues (optional) 
     * @param filter (optional) 
     * @return OK
     */
    dataSourceDeps(domainId: string, versionId: string | undefined, dependenciesNames: string[] | undefined, dependenciesValues: string[] | undefined, filter: string | undefined): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/data-domain/data-source-deps/{domainId}?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (dependenciesNames === null)
            throw new Error("The parameter 'dependenciesNames' cannot be null.");
        else if (dependenciesNames !== undefined)
            dependenciesNames && dependenciesNames.forEach(item => { url_ += "dependenciesNames=" + encodeURIComponent("" + item) + "&"; });
        if (dependenciesValues === null)
            throw new Error("The parameter 'dependenciesValues' cannot be null.");
        else if (dependenciesValues !== undefined)
            dependenciesValues && dependenciesValues.forEach(item => { url_ += "dependenciesValues=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataSourceDeps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataSourceDeps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processDataSourceDeps(response: HttpResponseBase): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataDomainSourceDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param versionId (optional) 
     * @param dependenciesNames (optional) 
     * @param dependenciesValues (optional) 
     * @param filter (optional) 
     * @return OK
     */
    dataSourceDepsGuest(domainId: string, versionId: string | undefined, dependenciesNames: string[] | undefined, dependenciesValues: string[] | undefined, filter: string | undefined): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/data-domain/data-source-deps-guest/{domainId}?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (dependenciesNames === null)
            throw new Error("The parameter 'dependenciesNames' cannot be null.");
        else if (dependenciesNames !== undefined)
            dependenciesNames && dependenciesNames.forEach(item => { url_ += "dependenciesNames=" + encodeURIComponent("" + item) + "&"; });
        if (dependenciesValues === null)
            throw new Error("The parameter 'dependenciesValues' cannot be null.");
        else if (dependenciesValues !== undefined)
            dependenciesValues && dependenciesValues.forEach(item => { url_ += "dependenciesValues=" + encodeURIComponent("" + item) + "&"; });
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataSourceDepsGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataSourceDepsGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataDomainSourceDataOutputDtoEntityActionResultDto>;
        }));
    }

    protected processDataSourceDepsGuest(response: HttpResponseBase): Observable<DataDomainSourceDataOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataDomainSourceDataOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @return OK
     */
    newFlowInfo(templateId: string): Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/flow/new-flow-info/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewFlowInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewFlowInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto>;
        }));
    }

    protected processNewFlowInfo(response: HttpResponseBase): Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartFlowRenderInfoOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    newGuestFlowInfo(templateId: string): Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/flow/new-guest-flow-info/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewGuestFlowInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewGuestFlowInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto>;
        }));
    }

    protected processNewGuestFlowInfo(response: HttpResponseBase): Observable<StartFlowRenderInfoOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartFlowRenderInfoOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formType (optional) 
     * @return OK
     */
    renderInfo(flowId: string, formType: number | undefined): Observable<FlowRenderInfoOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/flow/render-info/{flowId}?";
        if (flowId === undefined || flowId === null)
            throw new Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        if (formType === null)
            throw new Error("The parameter 'formType' cannot be null.");
        else if (formType !== undefined)
            url_ += "formType=" + encodeURIComponent("" + formType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlowRenderInfoOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlowRenderInfoOutputDtoEntityActionResultDto>;
        }));
    }

    protected processRenderInfo(response: HttpResponseBase): Observable<FlowRenderInfoOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlowRenderInfoOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    start(body: StartFlowInputDto | undefined): Observable<StartFlowResultOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/flow/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartFlowResultOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartFlowResultOutputDtoEntityActionResultDto>;
        }));
    }

    protected processStart(response: HttpResponseBase): Observable<StartFlowResultOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartFlowResultOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    startGuest(body: StartFlowAsGuestInputDto | undefined): Observable<StartFlowResultOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/flow/start-guest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartFlowResultOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartFlowResultOutputDtoEntityActionResultDto>;
        }));
    }

    protected processStartGuest(response: HttpResponseBase): Observable<StartFlowResultOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartFlowResultOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    edit(body: SaveFlowInputDto | undefined): Observable<ActionResultDto> {
        let url_ = this.baseUrl + "/flow/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionResultDto>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<ActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param packageId (optional) 
     * @param type (optional) 
     * @return OK
     */
    getFlowFormsScope(packageId: string | undefined, type: string | undefined): Observable<FlowFormScopesOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/Forms/GetFlowFormsScope?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowFormsScope(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowFormsScope(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlowFormScopesOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlowFormScopesOutputDtoEntityActionResultDto>;
        }));
    }

    protected processGetFlowFormsScope(response: HttpResponseBase): Observable<FlowFormScopesOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlowFormScopesOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ActionResultDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocalizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param culture (optional) 
     * @return OK
     */
    getLocalizationsByCulture(culture: string | undefined): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Localization/GetLocalizationsByCulture?";
        if (culture === null)
            throw new Error("The parameter 'culture' cannot be null.");
        else if (culture !== undefined)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalizationsByCulture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalizationsByCulture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetLocalizationsByCulture(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param templateRoleId (optional) 
     * @param versionId (optional) 
     * @param searchTerm (optional) 
     * @return OK
     */
    possibleMember(templateRoleId: string | undefined, versionId: string | undefined, searchTerm: string | undefined): Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto> {
        let url_ = this.baseUrl + "/role/possible-member?";
        if (templateRoleId === null)
            throw new Error("The parameter 'templateRoleId' cannot be null.");
        else if (templateRoleId !== undefined)
            url_ += "templateRoleId=" + encodeURIComponent("" + templateRoleId) + "&";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPossibleMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPossibleMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto>;
        }));
    }

    protected processPossibleMember(response: HttpResponseBase): Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateRoleMemberOutputDtoListEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param templateRoleId (optional) 
     * @param versionId (optional) 
     * @param searchTerm (optional) 
     * @return OK
     */
    possibleMemberGuest(templateRoleId: string | undefined, versionId: string | undefined, searchTerm: string | undefined): Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto> {
        let url_ = this.baseUrl + "/role/possible-member-guest?";
        if (templateRoleId === null)
            throw new Error("The parameter 'templateRoleId' cannot be null.");
        else if (templateRoleId !== undefined)
            url_ += "templateRoleId=" + encodeURIComponent("" + templateRoleId) + "&";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPossibleMemberGuest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPossibleMemberGuest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto>;
        }));
    }

    protected processPossibleMemberGuest(response: HttpResponseBase): Observable<TemplateRoleMemberOutputDtoListEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateRoleMemberOutputDtoListEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ActionResultDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @return OK
     */
    currentUser(): Observable<CurrentUserOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/session/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserOutputDtoEntityActionResultDto>;
        }));
    }

    protected processCurrentUser(response: HttpResponseBase): Observable<CurrentUserOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ActionResultDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/Qflow.Task.Angular.Backend";
    }

    /**
     * @param flowId (optional) 
     * @param taskId (optional) 
     * @param taskToId (optional) 
     * @return OK
     */
    taskRenderInfo(flowId: string | undefined, taskId: string | undefined, taskToId: string | undefined): Observable<TaskRenderInfoOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/task/task-render-info?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (taskToId === null)
            throw new Error("The parameter 'taskToId' cannot be null.");
        else if (taskToId !== undefined)
            url_ += "TaskToId=" + encodeURIComponent("" + taskToId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskRenderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskRenderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskRenderInfoOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskRenderInfoOutputDtoEntityActionResultDto>;
        }));
    }

    protected processTaskRenderInfo(response: HttpResponseBase): Observable<TaskRenderInfoOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskRenderInfoOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    guestTaskRenderInfo(token: string | undefined): Observable<GuestTaskRenderInfoOutputDtoEntityActionResultDto> {
        let url_ = this.baseUrl + "/task/guest-task-render-info?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuestTaskRenderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuestTaskRenderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuestTaskRenderInfoOutputDtoEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuestTaskRenderInfoOutputDtoEntityActionResultDto>;
        }));
    }

    protected processGuestTaskRenderInfo(response: HttpResponseBase): Observable<GuestTaskRenderInfoOutputDtoEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestTaskRenderInfoOutputDtoEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    respondTask(body: RespondTaskInputDto | undefined): Observable<TaskResponseResultEntityActionResultDto> {
        let url_ = this.baseUrl + "/task/respond-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRespondTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRespondTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResponseResultEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResponseResultEntityActionResultDto>;
        }));
    }

    protected processRespondTask(response: HttpResponseBase): Observable<TaskResponseResultEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseResultEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    respondGuestTask(body: RespondTaskAsGuestInputDto | undefined): Observable<TaskResponseResultEntityActionResultDto> {
        let url_ = this.baseUrl + "/task/respond-guest-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRespondGuestTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRespondGuestTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResponseResultEntityActionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResponseResultEntityActionResultDto>;
        }));
    }

    protected processRespondGuestTask(response: HttpResponseBase): Observable<TaskResponseResultEntityActionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseResultEntityActionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActionResultDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ActionResultDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActionResultDto implements IActionResultDto {
    success?: boolean;
    message!: string | undefined;

    constructor(data?: IActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IActionResultDto {
    success?: boolean;
    message: string | undefined;
}

export class AttachmentDataInputDto implements IAttachmentDataInputDto {
    name?: string | undefined;
    attachId?: string | undefined;
    attachVersion?: number | undefined;
    size?: number;
    refDataId?: string | undefined;

    constructor(data?: IAttachmentDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attachId = _data["attachId"];
            this.attachVersion = _data["attachVersion"];
            this.size = _data["size"];
            this.refDataId = _data["refDataId"];
        }
    }

    static fromJS(data: any): AttachmentDataInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attachId"] = this.attachId;
        data["attachVersion"] = this.attachVersion;
        data["size"] = this.size;
        data["refDataId"] = this.refDataId;
        return data;
    }
}

export interface IAttachmentDataInputDto {
    name?: string | undefined;
    attachId?: string | undefined;
    attachVersion?: number | undefined;
    size?: number;
    refDataId?: string | undefined;
}

export class AttachmentDataOutputDto implements IAttachmentDataOutputDto {
    name?: string | undefined;
    attachId?: string | undefined;
    attachVersion?: number | undefined;
    size?: number;

    constructor(data?: IAttachmentDataOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attachId = _data["attachId"];
            this.attachVersion = _data["attachVersion"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): AttachmentDataOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDataOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attachId"] = this.attachId;
        data["attachVersion"] = this.attachVersion;
        data["size"] = this.size;
        return data;
    }
}

export interface IAttachmentDataOutputDto {
    name?: string | undefined;
    attachId?: string | undefined;
    attachVersion?: number | undefined;
    size?: number;
}

export class AttachmentDataOutputDtoEntityActionResultDto implements IAttachmentDataOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: AttachmentDataOutputDto;

    constructor(data?: IAttachmentDataOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new AttachmentDataOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? AttachmentDataOutputDto.fromJS(_data["entity"]) : new AttachmentDataOutputDto();
        }
    }

    static fromJS(data: any): AttachmentDataOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDataOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAttachmentDataOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: AttachmentDataOutputDto;
}

export class AttachmentsScopeOutputDto implements IAttachmentsScopeOutputDto {
    maxAttachmentSize?: number;

    constructor(data?: IAttachmentsScopeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAttachmentSize = _data["maxAttachmentSize"];
        }
    }

    static fromJS(data: any): AttachmentsScopeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsScopeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAttachmentSize"] = this.maxAttachmentSize;
        return data;
    }
}

export interface IAttachmentsScopeOutputDto {
    maxAttachmentSize?: number;
}

export class CommentScopeOutputDto implements ICommentScopeOutputDto {
    allowAddition?: boolean;
    viewCommentHistory?: boolean;
    required?: boolean;

    constructor(data?: ICommentScopeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowAddition = _data["allowAddition"];
            this.viewCommentHistory = _data["viewCommentHistory"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): CommentScopeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentScopeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowAddition"] = this.allowAddition;
        data["viewCommentHistory"] = this.viewCommentHistory;
        data["required"] = this.required;
        return data;
    }
}

export interface ICommentScopeOutputDto {
    allowAddition?: boolean;
    viewCommentHistory?: boolean;
    required?: boolean;
}

export class ControlConfigurationOutputDto implements IControlConfigurationOutputDto {
    regularExpression!: string | undefined;
    specialMode!: string | undefined;
    dateCompareOperator!: string | undefined;
    dateToCompare!: string | undefined;
    displaySeconds!: string | undefined;
    isAmPmFormat!: string | undefined;
    hasEmptyOption?: boolean | undefined;
    maxValue?: number;
    minValue?: number;
    decimalPositions?: number;

    constructor(data?: IControlConfigurationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regularExpression = _data["regularExpression"];
            this.specialMode = _data["specialMode"];
            this.dateCompareOperator = _data["dateCompareOperator"];
            this.dateToCompare = _data["dateToCompare"];
            this.displaySeconds = _data["displaySeconds"];
            this.isAmPmFormat = _data["isAmPmFormat"];
            this.hasEmptyOption = _data["hasEmptyOption"];
            this.maxValue = _data["maxValue"];
            this.minValue = _data["minValue"];
            this.decimalPositions = _data["decimalPositions"];
        }
    }

    static fromJS(data: any): ControlConfigurationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlConfigurationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regularExpression"] = this.regularExpression;
        data["specialMode"] = this.specialMode;
        data["dateCompareOperator"] = this.dateCompareOperator;
        data["dateToCompare"] = this.dateToCompare;
        data["displaySeconds"] = this.displaySeconds;
        data["isAmPmFormat"] = this.isAmPmFormat;
        data["hasEmptyOption"] = this.hasEmptyOption;
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        data["decimalPositions"] = this.decimalPositions;
        return data;
    }
}

export interface IControlConfigurationOutputDto {
    regularExpression: string | undefined;
    specialMode: string | undefined;
    dateCompareOperator: string | undefined;
    dateToCompare: string | undefined;
    displaySeconds: string | undefined;
    isAmPmFormat: string | undefined;
    hasEmptyOption?: boolean | undefined;
    maxValue?: number;
    minValue?: number;
    decimalPositions?: number;
}

export class CurrentUserOutputDto implements ICurrentUserOutputDto {
    userId?: string;
    userName!: string | undefined;
    timeZone!: string | undefined;
    authorizedTools?: AuthorizedTools | undefined;

    constructor(data?: ICurrentUserOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.timeZone = _data["timeZone"];
            this.authorizedTools = _data["authorizedTools"] ? AuthorizedTools.fromJS(_data["authorizedTools"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentUserOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["timeZone"] = this.timeZone;
        data["authorizedTools"] = this.authorizedTools ? this.authorizedTools.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurrentUserOutputDto {
    userId?: string;
    userName: string | undefined;
    timeZone: string | undefined;
    authorizedTools?: AuthorizedTools | undefined;
}

export class CurrentUserOutputDtoEntityActionResultDto implements ICurrentUserOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: CurrentUserOutputDto;

    constructor(data?: ICurrentUserOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new CurrentUserOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? CurrentUserOutputDto.fromJS(_data["entity"]) : new CurrentUserOutputDto();
        }
    }

    static fromJS(data: any): CurrentUserOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurrentUserOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: CurrentUserOutputDto;
}

export class CustomFormOutputDto implements ICustomFormOutputDto {
    id?: string;
    templateVersionId?: string;
    name!: string | undefined;
    description!: string | undefined;
    content!: string | undefined;

    constructor(data?: ICustomFormOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateVersionId = _data["templateVersionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CustomFormOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFormOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateVersionId"] = this.templateVersionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["content"] = this.content;
        return data;
    }
}

export interface ICustomFormOutputDto {
    id?: string;
    templateVersionId?: string;
    name: string | undefined;
    description: string | undefined;
    content: string | undefined;
}

export class DataDomainSourceDataOutputDto implements IDataDomainSourceDataOutputDto {
    domainId?: string;
    options?: StringStringKeyValuePair[] | undefined;
    optionRowColumnValues?: string[][] | undefined;

    constructor(data?: IDataDomainSourceDataOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainId = _data["domainId"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(StringStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["optionRowColumnValues"])) {
                this.optionRowColumnValues = _data["optionRowColumnValues"];
            }
        }
    }

    static fromJS(data: any): DataDomainSourceDataOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataDomainSourceDataOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainId"] = this.domainId;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.optionRowColumnValues)) {
            data["optionRowColumnValues"] = [];
            for (let item of this.optionRowColumnValues)
                data["optionRowColumnValues"].push(item);
        }
        return data;
    }
}

export interface IDataDomainSourceDataOutputDto {
    domainId?: string;
    options?: StringStringKeyValuePair[] | undefined;
    optionRowColumnValues?: string[][] | undefined;
}

export class DataDomainSourceDataOutputDtoEntityActionResultDto implements IDataDomainSourceDataOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: DataDomainSourceDataOutputDto;

    constructor(data?: IDataDomainSourceDataOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new DataDomainSourceDataOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? DataDomainSourceDataOutputDto.fromJS(_data["entity"]) : new DataDomainSourceDataOutputDto();
        }
    }

    static fromJS(data: any): DataDomainSourceDataOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataDomainSourceDataOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataDomainSourceDataOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: DataDomainSourceDataOutputDto;
}

export class DomainOutputDto implements IDomainOutputDto {
    id?: string;
    maxLength?: number;
    controlConfiguration!: ControlConfigurationOutputDto;

    constructor(data?: IDomainOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.controlConfiguration = new ControlConfigurationOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maxLength = _data["maxLength"];
            this.controlConfiguration = _data["controlConfiguration"] ? ControlConfigurationOutputDto.fromJS(_data["controlConfiguration"]) : new ControlConfigurationOutputDto();
        }
    }

    static fromJS(data: any): DomainOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DomainOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maxLength"] = this.maxLength;
        data["controlConfiguration"] = this.controlConfiguration ? this.controlConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDomainOutputDto {
    id?: string;
    maxLength?: number;
    controlConfiguration: ControlConfigurationOutputDto;
}

export class FlowCommentOutputDto implements IFlowCommentOutputDto {
    comment!: string | undefined;
    userName!: string | undefined;
    response!: string | undefined;
    flowStepName!: string | undefined;
    date?: Date;
    action?: number;

    constructor(data?: IFlowCommentOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.userName = _data["userName"];
            this.response = _data["response"];
            this.flowStepName = _data["flowStepName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): FlowCommentOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowCommentOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["userName"] = this.userName;
        data["response"] = this.response;
        data["flowStepName"] = this.flowStepName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IFlowCommentOutputDto {
    comment: string | undefined;
    userName: string | undefined;
    response: string | undefined;
    flowStepName: string | undefined;
    date?: Date;
    action?: number;
}

export class FlowDataDependencyOutputDto implements IFlowDataDependencyOutputDto {
    parameterName?: string | undefined;
    parameterDirection?: number;
    dataId?: string;
    columnIndex?: number;

    constructor(data?: IFlowDataDependencyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterName = _data["parameterName"];
            this.parameterDirection = _data["parameterDirection"];
            this.dataId = _data["dataId"];
            this.columnIndex = _data["columnIndex"];
        }
    }

    static fromJS(data: any): FlowDataDependencyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowDataDependencyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterName"] = this.parameterName;
        data["parameterDirection"] = this.parameterDirection;
        data["dataId"] = this.dataId;
        data["columnIndex"] = this.columnIndex;
        return data;
    }
}

export interface IFlowDataDependencyOutputDto {
    parameterName?: string | undefined;
    parameterDirection?: number;
    dataId?: string;
    columnIndex?: number;
}

export class FlowDataOutputDto implements IFlowDataOutputDto {
    id?: string;
    domain!: DomainOutputDto;
    name!: string | undefined;
    value!: any | undefined;
    scope?: ItemScope;
    dependencies?: FlowDataDependencyOutputDto[] | undefined;

    constructor(data?: IFlowDataOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.domain = new DomainOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domain = _data["domain"] ? DomainOutputDto.fromJS(_data["domain"]) : new DomainOutputDto();
            this.name = _data["name"];
            this.value = _data["value"];
            this.scope = _data["scope"];
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(FlowDataDependencyOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlowDataOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowDataOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain ? this.domain.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["value"] = this.value;
        data["scope"] = this.scope;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlowDataOutputDto {
    id?: string;
    domain: DomainOutputDto;
    name: string | undefined;
    value: any | undefined;
    scope?: ItemScope;
    dependencies?: FlowDataDependencyOutputDto[] | undefined;
}

export class FlowFormScopesOutputDto implements IFlowFormScopesOutputDto {
    dataScopes?: { [key: string]: ItemScope; } | undefined;
    allowAdition?: boolean;
    viewHistory?: boolean;
    required?: boolean;

    constructor(data?: IFlowFormScopesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["dataScopes"]) {
                this.dataScopes = {} as any;
                for (let key in _data["dataScopes"]) {
                    if (_data["dataScopes"].hasOwnProperty(key))
                        (<any>this.dataScopes)![key] = _data["dataScopes"][key];
                }
            }
            this.allowAdition = _data["allowAdition"];
            this.viewHistory = _data["viewHistory"];
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): FlowFormScopesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowFormScopesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dataScopes) {
            data["dataScopes"] = {};
            for (let key in this.dataScopes) {
                if (this.dataScopes.hasOwnProperty(key))
                    (<any>data["dataScopes"])[key] = (<any>this.dataScopes)[key];
            }
        }
        data["allowAdition"] = this.allowAdition;
        data["viewHistory"] = this.viewHistory;
        data["required"] = this.required;
        return data;
    }
}

export interface IFlowFormScopesOutputDto {
    dataScopes?: { [key: string]: ItemScope; } | undefined;
    allowAdition?: boolean;
    viewHistory?: boolean;
    required?: boolean;
}

export class FlowFormScopesOutputDtoEntityActionResultDto implements IFlowFormScopesOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: FlowFormScopesOutputDto;

    constructor(data?: IFlowFormScopesOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new FlowFormScopesOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? FlowFormScopesOutputDto.fromJS(_data["entity"]) : new FlowFormScopesOutputDto();
        }
    }

    static fromJS(data: any): FlowFormScopesOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowFormScopesOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlowFormScopesOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: FlowFormScopesOutputDto;
}

export class FlowRenderInfoOutputDto implements IFlowRenderInfoOutputDto {
    flowId?: string;
    flowCorrelativeId?: number;
    versionId?: string;
    flowName!: string | undefined;
    isReadOnly?: boolean;
    flowDatas?: FlowDataOutputDto[] | undefined;
    flowRoles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm!: CustomFormOutputDto;
    scope!: ScopeOutputDto;
    initiatorUserName?: string;
    startDate?: Date;
    status?: string;
    importance?: string;
    flag?: string;
    progress?: number;
    flowDescription?: string;

    constructor(data?: IFlowRenderInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customForm = new CustomFormOutputDto();
            this.scope = new ScopeOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowId = _data["flowId"];
            this.flowCorrelativeId = _data["flowCorrelativeId"];
            this.versionId = _data["versionId"];
            this.flowName = _data["flowName"];
            this.isReadOnly = _data["isReadOnly"];
            if (Array.isArray(_data["flowDatas"])) {
                this.flowDatas = [] as any;
                for (let item of _data["flowDatas"])
                    this.flowDatas!.push(FlowDataOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["flowRoles"])) {
                this.flowRoles = [] as any;
                for (let item of _data["flowRoles"])
                    this.flowRoles!.push(FlowRoleOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(FlowCommentOutputDto.fromJS(item));
            }
            this.customForm = _data["customForm"] ? CustomFormOutputDto.fromJS(_data["customForm"]) : new CustomFormOutputDto();
            this.scope = _data["scope"] ? ScopeOutputDto.fromJS(_data["scope"]) : new ScopeOutputDto();
            this.initiatorUserName = _data["initiatorUserName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.importance = _data["importance"];
            this.flag = _data["flag"];
            this.progress = _data["progress"];
            this.flowDescription = _data["flowDescription"];
        }
    }

    static fromJS(data: any): FlowRenderInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowRenderInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowId"] = this.flowId;
        data["flowCorrelativeId"] = this.flowCorrelativeId;
        data["versionId"] = this.versionId;
        data["flowName"] = this.flowName;
        data["isReadOnly"] = this.isReadOnly;
        if (Array.isArray(this.flowDatas)) {
            data["flowDatas"] = [];
            for (let item of this.flowDatas)
                data["flowDatas"].push(item.toJSON());
        }
        if (Array.isArray(this.flowRoles)) {
            data["flowRoles"] = [];
            for (let item of this.flowRoles)
                data["flowRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["customForm"] = this.customForm ? this.customForm.toJSON() : <any>undefined;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["initiatorUserName"] = this.initiatorUserName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["importance"] = this.importance;
        data["flag"] = this.flag;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IFlowRenderInfoOutputDto {
    flowId?: string;
    flowCorrelativeId?: number;
    versionId?: string;
    flowName: string | undefined;
    isReadOnly?: boolean;
    flowDatas?: FlowDataOutputDto[] | undefined;
    flowRoles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm: CustomFormOutputDto;
    scope: ScopeOutputDto;
    initiatorUserName?: string;
    startDate?: Date;
    status?: string;
    importance?: string;
    flag?: string;
    progress?: number;
    flowDescription?: string;
}

export class FlowRenderInfoOutputDtoEntityActionResultDto implements IFlowRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: FlowRenderInfoOutputDto;

    constructor(data?: IFlowRenderInfoOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new FlowRenderInfoOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? FlowRenderInfoOutputDto.fromJS(_data["entity"]) : new FlowRenderInfoOutputDto();
        }
    }

    static fromJS(data: any): FlowRenderInfoOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowRenderInfoOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlowRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: FlowRenderInfoOutputDto;
}

export class FlowRoleInputDto implements IFlowRoleInputDto {
    id?: string;
    members?: RoleMemberInputDto[] | undefined;

    constructor(data?: IFlowRoleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(RoleMemberInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlowRoleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowRoleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlowRoleInputDto {
    id?: string;
    members?: RoleMemberInputDto[] | undefined;
}

export class FlowRoleOutputDto implements IFlowRoleOutputDto {
    id?: string;
    name!: string | undefined;
    allowsMultipleMembers?: boolean;
    scope?: ItemScope;
    members!: TemplateRoleMemberOutputDto[] | undefined;

    constructor(data?: IFlowRoleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.allowsMultipleMembers = _data["allowsMultipleMembers"];
            this.scope = _data["scope"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(TemplateRoleMemberOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlowRoleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowRoleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["allowsMultipleMembers"] = this.allowsMultipleMembers;
        data["scope"] = this.scope;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlowRoleOutputDto {
    id?: string;
    name: string | undefined;
    allowsMultipleMembers?: boolean;
    scope?: ItemScope;
    members: TemplateRoleMemberOutputDto[] | undefined;
}

export class GuestTaskRenderInfoOutputDto implements IGuestTaskRenderInfoOutputDto {
    taskId?: string;
    taskToId?: string;
    flowId?: string;
    templateStepId?: string;
    taskName!: string | undefined;
    subject!: string | undefined;
    isReadOnly?: boolean;
    responsesConfiguration!: ResponsesConfigurationOutputDto;
    data?: FlowDataOutputDto[] | undefined;
    roles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm!: CustomFormOutputDto;
    versionId?: string;
    scope!: ScopeOutputDto;
    token!: string | undefined;
    email!: string | undefined;

    constructor(data?: IGuestTaskRenderInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responsesConfiguration = new ResponsesConfigurationOutputDto();
            this.customForm = new CustomFormOutputDto();
            this.scope = new ScopeOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskToId = _data["taskToId"];
            this.flowId = _data["flowId"];
            this.templateStepId = _data["templateStepId"];
            this.taskName = _data["taskName"];
            this.subject = _data["subject"];
            this.isReadOnly = _data["isReadOnly"];
            this.responsesConfiguration = _data["responsesConfiguration"] ? ResponsesConfigurationOutputDto.fromJS(_data["responsesConfiguration"]) : new ResponsesConfigurationOutputDto();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FlowDataOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(FlowCommentOutputDto.fromJS(item));
            }
            this.customForm = _data["customForm"] ? CustomFormOutputDto.fromJS(_data["customForm"]) : new CustomFormOutputDto();
            this.versionId = _data["versionId"];
            this.scope = _data["scope"] ? ScopeOutputDto.fromJS(_data["scope"]) : new ScopeOutputDto();
            this.token = _data["token"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GuestTaskRenderInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestTaskRenderInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskToId"] = this.taskToId;
        data["flowId"] = this.flowId;
        data["templateStepId"] = this.templateStepId;
        data["taskName"] = this.taskName;
        data["subject"] = this.subject;
        data["isReadOnly"] = this.isReadOnly;
        data["responsesConfiguration"] = this.responsesConfiguration ? this.responsesConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["customForm"] = this.customForm ? this.customForm.toJSON() : <any>undefined;
        data["versionId"] = this.versionId;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["token"] = this.token;
        data["email"] = this.email;
        return data;
    }
}

export interface IGuestTaskRenderInfoOutputDto {
    taskId?: string;
    taskToId?: string;
    flowId?: string;
    templateStepId?: string;
    taskName: string | undefined;
    subject: string | undefined;
    isReadOnly?: boolean;
    responsesConfiguration: ResponsesConfigurationOutputDto;
    data?: FlowDataOutputDto[] | undefined;
    roles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm: CustomFormOutputDto;
    versionId?: string;
    scope: ScopeOutputDto;
    token: string | undefined;
    email: string | undefined;
}

export class GuestTaskRenderInfoOutputDtoEntityActionResultDto implements IGuestTaskRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: GuestTaskRenderInfoOutputDto;

    constructor(data?: IGuestTaskRenderInfoOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new GuestTaskRenderInfoOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? GuestTaskRenderInfoOutputDto.fromJS(_data["entity"]) : new GuestTaskRenderInfoOutputDto();
        }
    }

    static fromJS(data: any): GuestTaskRenderInfoOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestTaskRenderInfoOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGuestTaskRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: GuestTaskRenderInfoOutputDto;
}

export class GuidStringKeyValuePair implements IGuidStringKeyValuePair {
    key?: string;
    value?: string | undefined;

    constructor(data?: IGuidStringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GuidStringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new GuidStringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IGuidStringKeyValuePair {
    key?: string;
    value?: string | undefined;
}

export enum ItemScope {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class RespondTaskAsGuestInputDto implements IRespondTaskAsGuestInputDto {
    flowId?: string;
    taskId?: string;
    taskToId?: string;
    responseKey!: string | undefined;
    dataIdsWithValues!: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments!: AttachmentDataInputDto[] | undefined;
    comment!: string | undefined;
    email!: string | undefined;
    token!: string | undefined;

    constructor(data?: IRespondTaskAsGuestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowId = _data["flowId"];
            this.taskId = _data["taskId"];
            this.taskToId = _data["taskToId"];
            this.responseKey = _data["responseKey"];
            if (Array.isArray(_data["dataIdsWithValues"])) {
                this.dataIdsWithValues = [] as any;
                for (let item of _data["dataIdsWithValues"])
                    this.dataIdsWithValues!.push(GuidStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleInputDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDataInputDto.fromJS(item));
            }
            this.comment = _data["comment"];
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RespondTaskAsGuestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RespondTaskAsGuestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowId"] = this.flowId;
        data["taskId"] = this.taskId;
        data["taskToId"] = this.taskToId;
        data["responseKey"] = this.responseKey;
        if (Array.isArray(this.dataIdsWithValues)) {
            data["dataIdsWithValues"] = [];
            for (let item of this.dataIdsWithValues)
                data["dataIdsWithValues"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    }
}

export interface IRespondTaskAsGuestInputDto {
    flowId?: string;
    taskId?: string;
    taskToId?: string;
    responseKey: string | undefined;
    dataIdsWithValues: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments: AttachmentDataInputDto[] | undefined;
    comment: string | undefined;
    email: string | undefined;
    token: string | undefined;
}

export class RespondTaskInputDto implements IRespondTaskInputDto {
    flowId?: string;
    taskId?: string;
    taskToId?: string;
    responseKey!: string | undefined;
    dataIdsWithValues!: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments!: AttachmentDataInputDto[] | undefined;
    comment!: string | undefined;

    constructor(data?: IRespondTaskInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowId = _data["flowId"];
            this.taskId = _data["taskId"];
            this.taskToId = _data["taskToId"];
            this.responseKey = _data["responseKey"];
            if (Array.isArray(_data["dataIdsWithValues"])) {
                this.dataIdsWithValues = [] as any;
                for (let item of _data["dataIdsWithValues"])
                    this.dataIdsWithValues!.push(GuidStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleInputDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDataInputDto.fromJS(item));
            }
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RespondTaskInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RespondTaskInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowId"] = this.flowId;
        data["taskId"] = this.taskId;
        data["taskToId"] = this.taskToId;
        data["responseKey"] = this.responseKey;
        if (Array.isArray(this.dataIdsWithValues)) {
            data["dataIdsWithValues"] = [];
            for (let item of this.dataIdsWithValues)
                data["dataIdsWithValues"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        return data;
    }
}

export interface IRespondTaskInputDto {
    flowId?: string;
    taskId?: string;
    taskToId?: string;
    responseKey: string | undefined;
    dataIdsWithValues: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments: AttachmentDataInputDto[] | undefined;
    comment: string | undefined;
}

export class ResponsesConfigurationOutputDto implements IResponsesConfigurationOutputDto {
    responses?: TaskResponseOutputDto[] | undefined;
    responseKey?: string | undefined;

    constructor(data?: IResponsesConfigurationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(TaskResponseOutputDto.fromJS(item));
            }
            this.responseKey = _data["responseKey"];
        }
    }

    static fromJS(data: any): ResponsesConfigurationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsesConfigurationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["responseKey"] = this.responseKey;
        return data;
    }
}

export interface IResponsesConfigurationOutputDto {
    responses?: TaskResponseOutputDto[] | undefined;
    responseKey?: string | undefined;
}

export class RoleMemberInputDto implements IRoleMemberInputDto {
    id?: string;
    templateRoleMemberType?: TemplateRoleMemberType;

    constructor(data?: IRoleMemberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateRoleMemberType = _data["templateRoleMemberType"];
        }
    }

    static fromJS(data: any): RoleMemberInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleMemberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateRoleMemberType"] = this.templateRoleMemberType;
        return data;
    }
}

export interface IRoleMemberInputDto {
    id?: string;
    templateRoleMemberType?: TemplateRoleMemberType;
}

export class SaveFlowInputDto implements ISaveFlowInputDto {
    flowId?: string;
    versionId?: string;
    dataIdsWithValues?: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments?: AttachmentDataInputDto[] | undefined;
    comment?: string | undefined;
    flowName?: string | undefined;
    flowDescription?: string | undefined;
    importance?: string | undefined;
    flag?: string | undefined;
    progress?: number | undefined;

    constructor(data?: ISaveFlowInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowId = _data["flowId"];
            this.versionId = _data["versionId"];
            if (Array.isArray(_data["dataIdsWithValues"])) {
                this.dataIdsWithValues = [] as any;
                for (let item of _data["dataIdsWithValues"])
                    this.dataIdsWithValues!.push(GuidStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleInputDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDataInputDto.fromJS(item));
            }
            this.comment = _data["comment"];
            this.flowName = _data["flowName"];
            this.flowDescription = _data["flowDescription"];
            this.importance = _data["importance"];
            this.flag = _data["flag"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): SaveFlowInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFlowInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowId"] = this.flowId;
        data["versionId"] = this.versionId;
        if (Array.isArray(this.dataIdsWithValues)) {
            data["dataIdsWithValues"] = [];
            for (let item of this.dataIdsWithValues)
                data["dataIdsWithValues"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["flowName"] = this.flowName;
        data["flowDescription"] = this.flowDescription;
        data["importance"] = this.importance;
        data["flag"] = this.flag;
        data["progress"] = this.progress;
        return data;
    }
}

export interface ISaveFlowInputDto {
    flowId?: string;
    versionId?: string;
    dataIdsWithValues?: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments?: AttachmentDataInputDto[] | undefined;
    comment?: string | undefined;
    flowName?: string | undefined;
    flowDescription?: string | undefined;
    importance?: string | undefined;
    flag?: string | undefined;
    progress?: number | undefined;
}

export class ScopeOutputDto implements IScopeOutputDto {
    commentScope!: CommentScopeOutputDto;
    attachmentsScope!: AttachmentsScopeOutputDto;

    constructor(data?: IScopeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.commentScope = new CommentScopeOutputDto();
            this.attachmentsScope = new AttachmentsScopeOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentScope = _data["commentScope"] ? CommentScopeOutputDto.fromJS(_data["commentScope"]) : new CommentScopeOutputDto();
            this.attachmentsScope = _data["attachmentsScope"] ? AttachmentsScopeOutputDto.fromJS(_data["attachmentsScope"]) : new AttachmentsScopeOutputDto();
        }
    }

    static fromJS(data: any): ScopeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentScope"] = this.commentScope ? this.commentScope.toJSON() : <any>undefined;
        data["attachmentsScope"] = this.attachmentsScope ? this.attachmentsScope.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScopeOutputDto {
    commentScope: CommentScopeOutputDto;
    attachmentsScope: AttachmentsScopeOutputDto;
}

export class StartFlowAsGuestInputDto implements IStartFlowAsGuestInputDto {
    versionId?: string;
    templateId?: string;
    flowName!: string | undefined;
    flowDescription!: string | undefined;
    dataIdsWithValues!: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments!: AttachmentDataInputDto[] | undefined;
    comment!: string | undefined;
    captchaToken!: string | undefined;

    constructor(data?: IStartFlowAsGuestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.templateId = _data["templateId"];
            this.flowName = _data["flowName"];
            this.flowDescription = _data["flowDescription"];
            if (Array.isArray(_data["dataIdsWithValues"])) {
                this.dataIdsWithValues = [] as any;
                for (let item of _data["dataIdsWithValues"])
                    this.dataIdsWithValues!.push(GuidStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleInputDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDataInputDto.fromJS(item));
            }
            this.comment = _data["comment"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): StartFlowAsGuestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowAsGuestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["templateId"] = this.templateId;
        data["flowName"] = this.flowName;
        data["flowDescription"] = this.flowDescription;
        if (Array.isArray(this.dataIdsWithValues)) {
            data["dataIdsWithValues"] = [];
            for (let item of this.dataIdsWithValues)
                data["dataIdsWithValues"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}

export interface IStartFlowAsGuestInputDto {
    versionId?: string;
    templateId?: string;
    flowName: string | undefined;
    flowDescription: string | undefined;
    dataIdsWithValues: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments: AttachmentDataInputDto[] | undefined;
    comment: string | undefined;
    captchaToken: string | undefined;
}

export class StartFlowInputDto implements IStartFlowInputDto {
    versionId?: string;
    templateId?: string;
    flowName!: string | undefined;
    flowDescription!: string | undefined;
    dataIdsWithValues!: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments!: AttachmentDataInputDto[] | undefined;
    comment!: string | undefined;

    constructor(data?: IStartFlowInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.templateId = _data["templateId"];
            this.flowName = _data["flowName"];
            this.flowDescription = _data["flowDescription"];
            if (Array.isArray(_data["dataIdsWithValues"])) {
                this.dataIdsWithValues = [] as any;
                for (let item of _data["dataIdsWithValues"])
                    this.dataIdsWithValues!.push(GuidStringKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleInputDto.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentDataInputDto.fromJS(item));
            }
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): StartFlowInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["templateId"] = this.templateId;
        data["flowName"] = this.flowName;
        data["flowDescription"] = this.flowDescription;
        if (Array.isArray(this.dataIdsWithValues)) {
            data["dataIdsWithValues"] = [];
            for (let item of this.dataIdsWithValues)
                data["dataIdsWithValues"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        return data;
    }
}

export interface IStartFlowInputDto {
    versionId?: string;
    templateId?: string;
    flowName: string | undefined;
    flowDescription: string | undefined;
    dataIdsWithValues: GuidStringKeyValuePair[] | undefined;
    roles?: FlowRoleInputDto[] | undefined;
    attachments: AttachmentDataInputDto[] | undefined;
    comment: string | undefined;
}

export class StartFlowRenderInfoOutputDto implements IStartFlowRenderInfoOutputDto {
    templateId?: string;
    versionId?: string;
    templateName!: string | undefined;
    versionName!: string | undefined;
    flowDatas?: FlowDataOutputDto[] | undefined;
    flowRoles?: FlowRoleOutputDto[] | undefined;
    customForm!: CustomFormOutputDto;
    autoGenerateName?: boolean;
    autoGenerateDescription?: boolean;
    scope!: ScopeOutputDto;

    constructor(data?: IStartFlowRenderInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customForm = new CustomFormOutputDto();
            this.scope = new ScopeOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.versionId = _data["versionId"];
            this.templateName = _data["templateName"];
            this.versionName = _data["versionName"];
            if (Array.isArray(_data["flowDatas"])) {
                this.flowDatas = [] as any;
                for (let item of _data["flowDatas"])
                    this.flowDatas!.push(FlowDataOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["flowRoles"])) {
                this.flowRoles = [] as any;
                for (let item of _data["flowRoles"])
                    this.flowRoles!.push(FlowRoleOutputDto.fromJS(item));
            }
            this.customForm = _data["customForm"] ? CustomFormOutputDto.fromJS(_data["customForm"]) : new CustomFormOutputDto();
            this.autoGenerateName = _data["autoGenerateName"];
            this.autoGenerateDescription = _data["autoGenerateDescription"];
            this.scope = _data["scope"] ? ScopeOutputDto.fromJS(_data["scope"]) : new ScopeOutputDto();
        }
    }

    static fromJS(data: any): StartFlowRenderInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowRenderInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["versionId"] = this.versionId;
        data["templateName"] = this.templateName;
        data["versionName"] = this.versionName;
        if (Array.isArray(this.flowDatas)) {
            data["flowDatas"] = [];
            for (let item of this.flowDatas)
                data["flowDatas"].push(item.toJSON());
        }
        if (Array.isArray(this.flowRoles)) {
            data["flowRoles"] = [];
            for (let item of this.flowRoles)
                data["flowRoles"].push(item.toJSON());
        }
        data["customForm"] = this.customForm ? this.customForm.toJSON() : <any>undefined;
        data["autoGenerateName"] = this.autoGenerateName;
        data["autoGenerateDescription"] = this.autoGenerateDescription;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStartFlowRenderInfoOutputDto {
    templateId?: string;
    versionId?: string;
    templateName: string | undefined;
    versionName: string | undefined;
    flowDatas?: FlowDataOutputDto[] | undefined;
    flowRoles?: FlowRoleOutputDto[] | undefined;
    customForm: CustomFormOutputDto;
    autoGenerateName?: boolean;
    autoGenerateDescription?: boolean;
    scope: ScopeOutputDto;
}

export class StartFlowRenderInfoOutputDtoEntityActionResultDto implements IStartFlowRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: StartFlowRenderInfoOutputDto;

    constructor(data?: IStartFlowRenderInfoOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new StartFlowRenderInfoOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? StartFlowRenderInfoOutputDto.fromJS(_data["entity"]) : new StartFlowRenderInfoOutputDto();
        }
    }

    static fromJS(data: any): StartFlowRenderInfoOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowRenderInfoOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStartFlowRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: StartFlowRenderInfoOutputDto;
}

export class StartFlowResultOutputDto implements IStartFlowResultOutputDto {
    flowId?: string;
    templateId?: string;
    versionId?: string;
    flowCorrelativeId?: number;
    name!: string | undefined;
    confirmationMessageToUser!: string | undefined;

    constructor(data?: IStartFlowResultOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowId = _data["flowId"];
            this.templateId = _data["templateId"];
            this.versionId = _data["versionId"];
            this.flowCorrelativeId = _data["flowCorrelativeId"];
            this.name = _data["name"];
            this.confirmationMessageToUser = _data["confirmationMessageToUser"];
        }
    }

    static fromJS(data: any): StartFlowResultOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowResultOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowId"] = this.flowId;
        data["templateId"] = this.templateId;
        data["versionId"] = this.versionId;
        data["flowCorrelativeId"] = this.flowCorrelativeId;
        data["name"] = this.name;
        data["confirmationMessageToUser"] = this.confirmationMessageToUser;
        return data;
    }
}

export interface IStartFlowResultOutputDto {
    flowId?: string;
    templateId?: string;
    versionId?: string;
    flowCorrelativeId?: number;
    name: string | undefined;
    confirmationMessageToUser: string | undefined;
}

export class StartFlowResultOutputDtoEntityActionResultDto implements IStartFlowResultOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: StartFlowResultOutputDto;

    constructor(data?: IStartFlowResultOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new StartFlowResultOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? StartFlowResultOutputDto.fromJS(_data["entity"]) : new StartFlowResultOutputDto();
        }
    }

    static fromJS(data: any): StartFlowResultOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartFlowResultOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStartFlowResultOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: StartFlowResultOutputDto;
}

export class StringStringKeyValuePair implements IStringStringKeyValuePair {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IStringStringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringStringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IStringStringKeyValuePair {
    key?: string | undefined;
    value?: string | undefined;
}

export class TaskRenderInfoOutputDto implements ITaskRenderInfoOutputDto {
    taskId?: string;
    taskToId?: string;
    flowId?: string;
    templateStepId?: string;
    taskName!: string | undefined;
    subject!: string | undefined;
    isReadOnly?: boolean;
    responsesConfiguration!: ResponsesConfigurationOutputDto;
    data?: FlowDataOutputDto[] | undefined;
    roles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm!: CustomFormOutputDto;
    versionId?: string;
    scope!: ScopeOutputDto;
    initiatorUserName?: string;
    startDate?: Date;
    status?: string;
    importance?: string;
    flag?: string;
    progress?: number;
    flowCorrelativeId?: number;
    flowDescription?: string;
    flowName?: string;

    constructor(data?: ITaskRenderInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.responsesConfiguration = new ResponsesConfigurationOutputDto();
            this.customForm = new CustomFormOutputDto();
            this.scope = new ScopeOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskToId = _data["taskToId"];
            this.flowId = _data["flowId"];
            this.templateStepId = _data["templateStepId"];
            this.taskName = _data["taskName"];
            this.subject = _data["subject"];
            this.isReadOnly = _data["isReadOnly"];
            this.responsesConfiguration = _data["responsesConfiguration"] ? ResponsesConfigurationOutputDto.fromJS(_data["responsesConfiguration"]) : new ResponsesConfigurationOutputDto();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FlowDataOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FlowRoleOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(FlowCommentOutputDto.fromJS(item));
            }
            this.customForm = _data["customForm"] ? CustomFormOutputDto.fromJS(_data["customForm"]) : new CustomFormOutputDto();
            this.versionId = _data["versionId"];
            this.scope = _data["scope"] ? ScopeOutputDto.fromJS(_data["scope"]) : new ScopeOutputDto();
            this.initiatorUserName = _data["initiatorUserName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.importance = _data["importance"];
            this.flag = _data["flag"];
            this.progress = _data["progress"];
            this.flowCorrelativeId = _data["flowCorrelativeId"];
            this.flowDescription = _data["flowDescription"];
            this.flowName = _data["flowName"];
        }
    }

    static fromJS(data: any): TaskRenderInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRenderInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskToId"] = this.taskToId;
        data["flowId"] = this.flowId;
        data["templateStepId"] = this.templateStepId;
        data["taskName"] = this.taskName;
        data["subject"] = this.subject;
        data["isReadOnly"] = this.isReadOnly;
        data["responsesConfiguration"] = this.responsesConfiguration ? this.responsesConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["customForm"] = this.customForm ? this.customForm.toJSON() : <any>undefined;
        data["versionId"] = this.versionId;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["initiatorUserName"] = this.initiatorUserName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["importance"] = this.importance;
        data["flag"] = this.flag;
        data["progress"] = this.progress;
        data["flowCorrelativeId"] = this.flowCorrelativeId;
        data["flowDescription"] = this.flowDescription;
        data["flowName"] = this.flowName;
        return data;
    }
}

export interface ITaskRenderInfoOutputDto {
    taskId?: string;
    taskToId?: string;
    flowId?: string;
    templateStepId?: string;
    taskName: string | undefined;
    subject: string | undefined;
    isReadOnly?: boolean;
    responsesConfiguration: ResponsesConfigurationOutputDto;
    data?: FlowDataOutputDto[] | undefined;
    roles?: FlowRoleOutputDto[] | undefined;
    comments?: FlowCommentOutputDto[] | undefined;
    customForm: CustomFormOutputDto;
    versionId?: string;
    scope: ScopeOutputDto;
    initiatorUserName?: string;
    startDate?: Date;
    status?: string;
    importance?: string;
    flag?: string;
    progress?: number;
    flowCorrelativeId?: number;
    flowDescription?: string;
    flowName?: string;
}

export class TaskRenderInfoOutputDtoEntityActionResultDto implements ITaskRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: TaskRenderInfoOutputDto;

    constructor(data?: ITaskRenderInfoOutputDtoEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new TaskRenderInfoOutputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? TaskRenderInfoOutputDto.fromJS(_data["entity"]) : new TaskRenderInfoOutputDto();
        }
    }

    static fromJS(data: any): TaskRenderInfoOutputDtoEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRenderInfoOutputDtoEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskRenderInfoOutputDtoEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: TaskRenderInfoOutputDto;
}

export class TaskResponseOutputDto implements ITaskResponseOutputDto {
    key!: string | undefined;
    value!: string | undefined;
    commentRequired?: boolean;

    constructor(data?: ITaskResponseOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.commentRequired = _data["commentRequired"];
        }
    }

    static fromJS(data: any): TaskResponseOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["commentRequired"] = this.commentRequired;
        return data;
    }
}

export interface ITaskResponseOutputDto {
    key: string | undefined;
    value: string | undefined;
    commentRequired?: boolean;
}

export class TaskResponseResult implements ITaskResponseResult {
    flowStepId?: string;
    flowStepToId?: string;
    flowId?: string;
    confirmationMessageToUser?: string | undefined;

    constructor(data?: ITaskResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowStepId = _data["flowStepId"];
            this.flowStepToId = _data["flowStepToId"];
            this.flowId = _data["flowId"];
            this.confirmationMessageToUser = _data["confirmationMessageToUser"];
        }
    }

    static fromJS(data: any): TaskResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowStepId"] = this.flowStepId;
        data["flowStepToId"] = this.flowStepToId;
        data["flowId"] = this.flowId;
        data["confirmationMessageToUser"] = this.confirmationMessageToUser;
        return data;
    }
}

export interface ITaskResponseResult {
    flowStepId?: string;
    flowStepToId?: string;
    flowId?: string;
    confirmationMessageToUser?: string | undefined;
}

export class TaskResponseResultEntityActionResultDto implements ITaskResponseResultEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: TaskResponseResult;

    constructor(data?: ITaskResponseResultEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entity = new TaskResponseResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.entity = _data["entity"] ? TaskResponseResult.fromJS(_data["entity"]) : new TaskResponseResult();
        }
    }

    static fromJS(data: any): TaskResponseResultEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseResultEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskResponseResultEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: TaskResponseResult;
}

export class TemplateRoleMemberOutputDto implements ITemplateRoleMemberOutputDto {
    id?: string;
    name!: string | undefined;
    templateRoleMemberType?: TemplateRoleMemberType;

    constructor(data?: ITemplateRoleMemberOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.templateRoleMemberType = _data["templateRoleMemberType"];
        }
    }

    static fromJS(data: any): TemplateRoleMemberOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateRoleMemberOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["templateRoleMemberType"] = this.templateRoleMemberType;
        return data;
    }
}

export interface ITemplateRoleMemberOutputDto {
    id?: string;
    name: string | undefined;
    templateRoleMemberType?: TemplateRoleMemberType;
}

export class TemplateRoleMemberOutputDtoListEntityActionResultDto implements ITemplateRoleMemberOutputDtoListEntityActionResultDto {
    success?: boolean;
    message!: string | undefined;
    entity!: TemplateRoleMemberOutputDto[] | undefined;

    constructor(data?: ITemplateRoleMemberOutputDtoListEntityActionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["entity"])) {
                this.entity = [] as any;
                for (let item of _data["entity"])
                    this.entity!.push(TemplateRoleMemberOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateRoleMemberOutputDtoListEntityActionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateRoleMemberOutputDtoListEntityActionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.entity)) {
            data["entity"] = [];
            for (let item of this.entity)
                data["entity"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateRoleMemberOutputDtoListEntityActionResultDto {
    success?: boolean;
    message: string | undefined;
    entity: TemplateRoleMemberOutputDto[] | undefined;
}

export enum TemplateRoleMemberType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class AuthorizedTools implements IAuthorizedTools {
    qflowWebSite?: string;
    qflowBPMWeb?: string;
    qflowOMM?: string;
    qflowSAMWeb?: string;

    constructor(data?: IAuthorizedTools) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qflowWebSite = _data["QflowWebSite"];
            this.qflowBPMWeb = _data["QflowBPMWeb"];
            this.qflowOMM = _data["QflowOMM"];
            this.qflowSAMWeb = _data["QflowSAMWeb"];
        }
    }

    static fromJS(data: any): AuthorizedTools {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedTools();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QflowWebSite"] = this.qflowWebSite;
        data["QflowBPMWeb"] = this.qflowBPMWeb;
        data["QflowOMM"] = this.qflowOMM;
        data["QflowSAMWeb"] = this.qflowSAMWeb;
        return data;
    }
}

export interface IAuthorizedTools {
    qflowWebSite?: string;
    qflowBPMWeb?: string;
    qflowOMM?: string;
    qflowSAMWeb?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}